import { updateReservationState } from "../../../data/repository/booking.repo";

export const UpdateBookingStateUseCase = async (reservation) => {
  try {
    const resp = await updateReservationState(reservation);
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
